import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  CmsConfig,
  I18nModule,
  provideDefaultConfig,
  UrlModule,
  ConfigModule,
} from '@spartacus/core'
import { SpinnerModule, IconModule } from '@spartacus/storefront'
import { MediaModule } from '@spartacus/storefront'
import { HighlightPipe } from './highlight.pipe'
import { SearchBoxComponent } from './search-box.component'
import { MatButtonModule } from '@angular/material/button'
import { CustomProductRoutesModule } from '../config/product-routes.module'
import { MatIconModule } from '@angular/material/icon'
import { MatDialogModule } from '@angular/material/dialog'
import { MatTooltipModule } from '@angular/material/tooltip'
import { ClickOutsideModule } from '../../shared/directive/clickOutside/click-outside.module'
import { environment } from '../../../environments/environment'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SpinnerModule,
    MediaModule,
    IconModule,
    UrlModule,
    I18nModule,
    MatButtonModule,
    CustomProductRoutesModule,
    MatIconModule,
    MatDialogModule,
    ClickOutsideModule,
    MatTooltipModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + 'assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['searchbox'],
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        SearchBoxComponent: {
          component: SearchBoxComponent,
        },
      },
    } as CmsConfig),
  ],
  declarations: [SearchBoxComponent, HighlightPipe],
  exports: [SearchBoxComponent],
})
export class SearchBoxModule {}
